// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { MaterialNameItemType } from 'types/routeManagementTypes';
import styles from './SelectCollectionMaterialCard.module.scss';
import { COLLECT_ROUTE_MATERIAL_COLOR_PALETTE } from 'util/constants/colorPalette';
import Popover from 'components/atoms/Popover';

interface Props {
  id: string;
  material: MaterialNameItemType;
  isSelected: boolean;
  onSelectMaterial: (material: MaterialNameItemType) => void;
}
const SelectCollectionMaterialCard: React.FC<Props> = ({
  id,
  material,
  isSelected,
  onSelectMaterial,
}) => {
  return (
    <div
      key={material.materialName}
      className={`${styles.material} ${isSelected ? styles.selected : ''}`}
      onClick={() => {
        onSelectMaterial(material);
      }}
    >
      <input id={id} hidden type="checkbox" checked={isSelected} readOnly />
      <span
        className={styles.dot}
        style={{
          backgroundColor:
            COLLECT_ROUTE_MATERIAL_COLOR_PALETTE[
              material.color % COLLECT_ROUTE_MATERIAL_COLOR_PALETTE.length
            ],
        }}
      />
      <Popover
        content={material.materialName}
        autoGen={{
          lines: 1,
        }}
        positions={['top']}
        containerStyle={{
          zIndex: '30001',
          maxWidth: '600px',
          wordBreak: 'break-all',
        }}
      >
        <p title={material.materialName}>{material.materialName}</p>
      </Popover>
    </div>
  );
};

export default SelectCollectionMaterialCard;
